export default __webpack_public_path__ + "static/media/crudjs.29f5a1c0.png";